import debug from "src/modules/debug-logger";
import { CACHE_NAME } from "src/modules/activity-log/constants";

export default async function getCachedResponse(fileName) {
  try {
    const cache = await caches.open(CACHE_NAME);
    const cacheKeys = await cache.keys();
    let cachedRequest = null;

    cacheKeys.some((request) => {
      if (request.url.includes(fileName)) {
        cachedRequest = request;
        return true;
      }
      return false;
    });

    if (cachedRequest) {
      return await cache.match(cachedRequest.url);
    } else return null;
  } catch (error) {
    debug.activityLog("Couldn't load resource from cache", error);
    return null;
  }
}
